module.exports = __webpack_public_path__ + "img/common_area.0d3cc463.jpg";